
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produtos/[slug]",
      function () {
        return require("private-next-pages/produtos/[slug].tsx");
      }
    ]);
  